import {DEFAULT_INTL} from '@/utils/constants/globalConstants'
import {AuthProvider} from '@/context/Auth/AuthProvider'
import useInternationalization from '@/internationalization/useInternationalization'
import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {IntlProvider} from 'react-intl'
import './assets/scss/App.scss'
import {store, persistor} from '@/store'
import {Provider} from 'react-redux'
import {PersistGate} from 'redux-persist/integration/react'
import {ThemeProvider} from 'pepsico-ds'
import {GrowthBookProvider} from '@growthbook/growthbook-react'
import gb from '@/utils/growthbookUtils'
import {useSetCSSVariables} from '@/utils/constants/colors'
import { AppRouter } from './routes/AppRouter'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
    },
  },
})

function App({shellActive = false, darkTheme = false, path = ''}) {
  const [language, message] = useInternationalization(DEFAULT_INTL)
  useSetCSSVariables()
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <GrowthBookProvider growthbook={gb}>
          <QueryClientProvider client={queryClient}>
            <IntlProvider locale={language} messages={message}>
              <AuthProvider>
                <ThemeProvider>
                  <AppRouter shellActive={shellActive} darkTheme={darkTheme} path={path} />
                </ThemeProvider>
              </AuthProvider>
            </IntlProvider>
          </QueryClientProvider>
        </GrowthBookProvider>
      </PersistGate>
    </Provider>
  )
}

export default App
